if (!customElements.get('trapt-quantity-breaks')) {
  customElements.define(
    'trapt-quantity-breaks',
    class TraptQuantityBreaks extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.input = this.querySelector('.quantity__input');
        if (!this.input || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.syncSelection();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        delete this.dataset.initialized;
      }

      onClick(event) {
        const option = event.target.closest('[data-quantity], [data-custom-quantity]');
        if (!option || !this.contains(option) || !this.input) return;

        if (option.hasAttribute('data-custom-quantity')) {
          const customInput = this.querySelector('.quantity__input-custom');
          if (!customInput) return;

          this.input.value = customInput.value;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          customInput.focus();
          return;
        }

        const quantity = Number.parseInt(option.dataset.quantity, 10);
        if (!Number.isFinite(quantity)) return;

        this.input.value = quantity;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onChange(event) {
        if (event.target.matches('.quantity__input-custom')) {
          this.input.value = event.target.value;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (event.target === this.input) this.syncSelection();
      }

      syncSelection() {
        if (!this.input) this.input = this.querySelector('.quantity__input');
        if (!this.input) return;

        const selectedQuantity = Number.parseInt(this.input.value, 10);
        const presetOptions = [...this.querySelectorAll('[data-quantity]')];
        const selectedPreset = presetOptions.find(
          (option) => Number.parseInt(option.dataset.quantity, 10) === selectedQuantity
        );

        presetOptions.forEach((option) => {
          const isSelected = Number.parseInt(option.dataset.quantity, 10) === selectedQuantity;
          option.classList.toggle('is-selected', isSelected);
          option.setAttribute('aria-pressed', String(isSelected));
        });

        const customOption = this.querySelector('[data-custom-quantity]');
        const customPanel = this.querySelector('.t986-custom-quantity');
        const customInput = this.querySelector('.quantity__input-custom');
        const customIsSelected = Boolean(customOption && !selectedPreset);

        if (customOption) {
          customOption.classList.toggle('is-selected', customIsSelected);
          customOption.setAttribute('aria-pressed', String(customIsSelected));
        }

        if (customPanel) customPanel.hidden = !customIsSelected;
        if (customIsSelected && customInput && Number.parseInt(customInput.value, 10) !== selectedQuantity) {
          customInput.value = selectedQuantity;
        }
      }
    }
  );
}
